const StoreSmCardLoader = ({ className }: any) => {
  return (
    <>
      <div
        className={
          className
            ? `${className} store-sm-card-loader`
            : 'store-sm-card-loader'
        }
      >
        <div className="img"></div>
        <p className="sm"></p>
      </div>
    </>
  );
};

export default StoreSmCardLoader;
